import { BeerOutlineIcon } from './BeerOutlineIcon';

/**
 * author: Simran
 * id 524E1789-7B3A-4BAD-9D04-2E8FD838DCFB
 * name beer-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/beer-outline.svg
 * tags
 * - Food / Drink 
 */
export const DrinkOutlineIcon = BeerOutlineIcon;
export default DrinkOutlineIcon